import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationOn300 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M531.11-506.58q21.2-21.19 21.2-51.11 0-29.92-21.2-51.12Q509.92-630 480-630q-29.92 0-51.11 21.19-21.2 21.2-21.2 51.12 0 29.92 21.2 51.11 21.19 21.19 51.11 21.19 29.92 0 51.11-21.19ZM480-179.46q117.38-105.08 179.65-201.58 62.27-96.5 62.27-169.04 0-109.38-69.5-179.84-69.5-70.46-172.42-70.46-102.92 0-172.42 70.46-69.5 70.46-69.5 179.84 0 72.54 62.27 169.04 62.27 96.5 179.65 201.58Zm0 79.84Q329-230.46 253.54-343.15q-75.46-112.7-75.46-206.93 0-138.46 89.57-224.19Q357.23-860 480-860t212.35 85.73q89.57 85.73 89.57 224.19 0 94.23-75.46 206.93Q631-230.46 480-99.62Zm0-458.07Z" })
});
export default SvgLocationOn300;
